class AudioPlayer {
    /** @property {HTMLAudioElement} audio */
    audio
    /** @property {Element} playPauseButton */
    playPauseButton
    /** @property {Element} progressBar */
    progressBar

    #progressIntervalID

    playingProgress = 0
    bufferedProgress = 0

    /**
     * @param {Object} config
     * @param {HTMLAudioElement} config.audio
     * @param {Element} config.playPauseButton
     * @param {Element} config.progressBar
     * */
    constructor(config) {
        this.audio = config.audio || null
        this.playPauseButton = config.playPauseButton || null
        this.progressBar = config.progressBar || null

        if (!this.audio || !this.playPauseButton) return;

        this.playPauseButton.addEventListener("click", async (event) => {
            if (this.audio.paused) {
                await this.play()
            } else {
                this.pause()
            }
        })

        this.audio.addEventListener("ended", () => {
            this.playPauseButton.classList.remove("playing")
            this.playPauseButton.classList.add("paused")

            if (this.progressBar) {
                this.progressBar.classList.remove("playing")
                this.progressBar.classList.add("paused")
                clearInterval(this.#progressIntervalID)
            }
        })

        this.audio.audioPlayer = this
    }

    async play() {
        this.#pauseAnyPlayers()

        await this.audio.play()

        this.playPauseButton.classList.add("playing")
        this.playPauseButton.classList.remove("paused")

        if (this.progressBar) {
            const progressPlayed = this.progressBar.querySelector(".played")
                , progressBuffered = this.progressBar.querySelector(".buffered")

            this.progressBar.classList.add("playing")
            this.progressBar.classList.remove("paused")

            this.#progressIntervalID = setInterval(() => {
                this.playingProgress = (this.audio.currentTime / this.audio.duration) * 100
                this.bufferedProgress = (this.audio.buffered.end(0) / this.audio.duration) * 100

                progressPlayed.style.width = `${this.playingProgress.toFixed(2)}%`
                progressBuffered.style.width = `${this.bufferedProgress.toFixed(2)}%`
            }, 50)
        }
    }

    pause() {
        this.audio.pause()

        this.playPauseButton.classList.remove("playing")
        this.playPauseButton.classList.add("paused")

        if (this.progressBar) {
            this.progressBar.classList.remove("playing")
            this.progressBar.classList.add("paused")
            clearInterval(this.#progressIntervalID)
        }
    }

    #pauseAnyPlayers() {
        document.querySelectorAll("audio").forEach(audio => {
            if (audio !== this.audio && audio.audioPlayer instanceof AudioPlayer) {
                audio.audioPlayer.pause()
            }
        })
    }
}

export default AudioPlayer
